import request from '@/utils/request'

const BASE = '/api/Extend/LqYcsdJsj'

export function getJsjList(data) {
  return request({
    url: BASE,
    method: 'get',
    data
  })
}

export function getJsjInfo(id) {
  return request({
    url: `${BASE}/${id}`,
    method: 'get'
  })
}

export function getJsjDetail(id) {
  return request({
    url: `${BASE}/${id}/detail`,
    method: 'get'
  })
}

export function createJsj(data) {
  return request({
    url: BASE,
    method: 'post',
    data
  })
}

export function updateJsj(id, data) {
  return request({
    url: `${BASE}/${id}`,
    method: 'put',
    data
  })
}

export function deleteJsj(id) {
  return request({
    url: `${BASE}/${id}`,
    method: 'delete'
  })
}

export function addUserToJsj(data) {
  return request({
    url: `${BASE}/Actions/AddUserToJsj`,
    method: 'post',
    data
  })
}

export function deleteJsjUserRelation(data) {
  return request({
    url: `${BASE}/Actions/DeleteJsjUserRelation`,
    method: 'post',
    data
  })
}
